module.exports = __webpack_public_path__ + "img/hotel-24.a910f6e4.jpeg";